// extracted by mini-css-extract-plugin
export default {"container":"MyRequest_container__VXN4b","master":"MyRequest_master__utxp6","content":"MyRequest_content__rjn6-"};